import React from 'react';
import { NavLink } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const navItems = [
  { to: '/home', icon: '\u{1F3E0}', label: 'Home' },
  { to: '/cart', icon: '\u{1F6D2}', label: 'Cart' },
  { to: '/history', icon: '\u{23F3}', label: 'History' },
  { to: '/settings', icon: '\u{2699}\u{FE0F}', label: 'Settings' },
];

export default function BottomNav() {
  const { isAuthenticated, cart } = useApp();
  if (!isAuthenticated) return null;

  const totalItems = Object.values(cart || {}).reduce(
    (sum, daily) => sum + Object.values(daily || {}).reduce((s, q) => s + q, 0),
    0
  );

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-20 flex items-center justify-around h-16 border-t border-orange-200 shadow-lg md:hidden bg-orange-50/95 backdrop-blur-md">
      {navItems.map(({ to, icon, label }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            `flex flex-col items-center justify-center w-full h-full text-xs font-medium ${
              isActive ? 'text-orange-600' : 'text-gray-500'
            } hover:text-orange-500 transition-colors duration-200`
          }
        >
          <span className="relative flex items-center justify-center text-xl">
            {icon}
            {label === 'Cart' && totalItems > 0 && (
              <span className="absolute flex items-center justify-center min-w-[18px] h-[18px] px-1 -top-2 -right-3 text-[10px] font-black leading-none text-white bg-orange-500 border-2 border-orange-50 rounded-full shadow-md">
                {totalItems > 99 ? '99+' : totalItems}
              </span>
            )}
          </span>
          <span className="mt-1">{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
